/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type VehicleMissionCardVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  isSelfDriving: boolean
  totalChildrenInVehicle: number | null
  totalPassengersInVehicle: number | null
  totalPassengersToPickUp: number | null
  totalWheelchairUsersInVehicle: number | null
  pooling: { __typename?: 'Pooling'; reason: Types.PoolingReason | null } | null
  currentlyLocatedInServiceBreakLocation: {
    __typename?: 'ServiceBreakLocation'
    id: string
  } | null
  fccUpcomingWaypoints: Array<{
    __typename?: 'FccWaypoint'
    id: string
    adState: Types.FccWaypointState | null
    adStateUpdatedAt: string | null
    routeProvider: Types.FccRouteProvider | null
    cabinSafetyCheckStatus: Types.FccCabinSafetyCheckStatus | null
    fccStop: {
      __typename?: 'FccStop'
      id: string | null
      names: Partial<Record<'de' | 'en' | 'no', string>>
    } | null
    stopWithServiceArea: {
      __typename?: 'Stop'
      id: string
      serviceArea: { __typename?: 'ServiceArea'; id: string }
    } | null
    actions: Array<
      | {
          __typename: 'FccWaypointDeliveryAction'
          id: string
          estimatedAt: string
          deliveryStatus: Types.FccWaypointDeliveryActionStatus
          promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
          customer: {
            __typename?: 'Customer'
            id: string
            firstName: string | null
            lastName: string | null
          } | null
          ridePassengerInfo: {
            __typename?: 'FccRidePassengerInfo'
            customerId: string | null
            displayName: string | null
            boardingRequirements: {
              __typename?: 'FccBoardingRequirements'
              headCount: number
              childSeat: boolean
              wheelchair: boolean
            } | null
          } | null
        }
      | {
          __typename: 'FccWaypointHubReturnAction'
          id: string
          estimatedAt: string
          reason: Types.FccWaypointHubReturnReason
          promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
          area: {
            __typename?: 'Area'
            id: string
            name: string | null
            type: Types.AreaType
            details:
              | { __typename?: 'CooperationDetails' }
              | { __typename?: 'HubDetails'; displayName: string }
              | { __typename?: 'InFieldBreakDetails' }
              | { __typename?: 'ShortBreakDetails' }
              | null
            serviceArea: { __typename?: 'ServiceArea'; id: string }
          } | null
        }
      | {
          __typename: 'FccWaypointPickupAction'
          id: string
          estimatedAt: string
          adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
          notShownUpAt: string | null
          tripIsCancelled: boolean | null
          pickupStatus: Types.FccWaypointPickupActionStatus
          promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
          customer: {
            __typename?: 'Customer'
            id: string
            firstName: string | null
            lastName: string | null
          } | null
          ridePassengerInfo: {
            __typename?: 'FccRidePassengerInfo'
            customerId: string | null
            displayName: string | null
            boardingRequirements: {
              __typename?: 'FccBoardingRequirements'
              headCount: number
              childSeat: boolean
              wheelchair: boolean
            } | null
          } | null
        }
      | {
          __typename: 'FccWaypointReallocationAction'
          id: string
          estimatedAt: string
          promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
        }
    >
  }> | null
}

export type VehicleMissionPickupActionFragment = {
  __typename: 'FccWaypointPickupAction'
  id: string
  estimatedAt: string
  adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
  notShownUpAt: string | null
  tripIsCancelled: boolean | null
  pickupStatus: Types.FccWaypointPickupActionStatus
  promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
  customer: {
    __typename?: 'Customer'
    id: string
    firstName: string | null
    lastName: string | null
  } | null
  ridePassengerInfo: {
    __typename?: 'FccRidePassengerInfo'
    customerId: string | null
    displayName: string | null
    boardingRequirements: {
      __typename?: 'FccBoardingRequirements'
      headCount: number
      childSeat: boolean
      wheelchair: boolean
    } | null
  } | null
}

export type VehicleMissionDeliveryActionFragment = {
  __typename: 'FccWaypointDeliveryAction'
  id: string
  estimatedAt: string
  deliveryStatus: Types.FccWaypointDeliveryActionStatus
  promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
  customer: {
    __typename?: 'Customer'
    id: string
    firstName: string | null
    lastName: string | null
  } | null
  ridePassengerInfo: {
    __typename?: 'FccRidePassengerInfo'
    customerId: string | null
    displayName: string | null
    boardingRequirements: {
      __typename?: 'FccBoardingRequirements'
      headCount: number
      childSeat: boolean
      wheelchair: boolean
    } | null
  } | null
}

export type VehicleMissionHubReturnActionFragment = {
  __typename: 'FccWaypointHubReturnAction'
  id: string
  estimatedAt: string
  reason: Types.FccWaypointHubReturnReason
  promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
  area: {
    __typename?: 'Area'
    id: string
    name: string | null
    type: Types.AreaType
    details:
      | { __typename?: 'CooperationDetails' }
      | { __typename?: 'HubDetails'; displayName: string }
      | { __typename?: 'InFieldBreakDetails' }
      | { __typename?: 'ShortBreakDetails' }
      | null
    serviceArea: { __typename?: 'ServiceArea'; id: string }
  } | null
}

export type VehicleMissionReallocationActionFragment = {
  __typename: 'FccWaypointReallocationAction'
  id: string
  estimatedAt: string
  promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
}

export const VehicleMissionPickupActionFragmentDoc = gql`
    fragment vehicleMissionPickupAction on FccWaypointPickupAction {
  __typename
  id
  promisedTimeRange {
    to
  }
  estimatedAt
  customer {
    id
    firstName
    lastName
  }
  ridePassengerInfo {
    customerId
    displayName
    boardingRequirements {
      headCount
      childSeat
      wheelchair
    }
  }
  adPassengerAuthenticationState
  notShownUpAt
  tripIsCancelled
  pickupStatus: status
}
    `
export const VehicleMissionDeliveryActionFragmentDoc = gql`
    fragment vehicleMissionDeliveryAction on FccWaypointDeliveryAction {
  __typename
  id
  promisedTimeRange {
    to
  }
  estimatedAt
  customer {
    id
    firstName
    lastName
  }
  ridePassengerInfo {
    customerId
    displayName
    boardingRequirements {
      headCount
      childSeat
      wheelchair
    }
  }
  deliveryStatus: status
}
    `
export const VehicleMissionHubReturnActionFragmentDoc = gql`
    fragment vehicleMissionHubReturnAction on FccWaypointHubReturnAction {
  __typename
  id
  promisedTimeRange {
    to
  }
  estimatedAt
  area {
    details {
      ... on HubDetails {
        displayName
      }
    }
    id
    serviceArea {
      id
    }
    name
    type
  }
  reason
}
    `
export const VehicleMissionReallocationActionFragmentDoc = gql`
    fragment vehicleMissionReallocationAction on FccWaypointReallocationAction {
  __typename
  id
  promisedTimeRange {
    to
  }
  estimatedAt
}
    `
export const VehicleMissionCardVehicleFragmentDoc = gql`
    fragment VehicleMissionCardVehicle on Vehicle {
  id
  pooling {
    reason
  }
  isSelfDriving
  currentlyLocatedInServiceBreakLocation {
    id
  }
  fccUpcomingWaypoints {
    id
    adState
    adStateUpdatedAt
    fccStop {
      id
      names
    }
    stopWithServiceArea: stop {
      id
      serviceArea {
        id
      }
    }
    actions {
      __typename
      ... on FccWaypointPickupAction {
        ...vehicleMissionPickupAction
      }
      ... on FccWaypointDeliveryAction {
        ...vehicleMissionDeliveryAction
      }
      ... on FccWaypointHubReturnAction {
        ...vehicleMissionHubReturnAction
      }
      ... on FccWaypointReallocationAction {
        ...vehicleMissionReallocationAction
      }
    }
    routeProvider
    cabinSafetyCheckStatus
  }
  ...VehicleMissionCardHeader
}
    `
